'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002417 from "./presto.-Dashboard-View$$anon$17.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dSystem$002dSite$002dStats$0024 from "./presto.types$-Dashboard-System-Site-Stats$.js";
import * as $j_presto$002etypes$0024$002dHost$0024 from "./presto.types$-Host$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$16() {
  this.aJQ = null;
  this.aJI = null;
  this.aJJ = false;
  this.aJR = null;
  this.aJS = false;
  this.aJV = null;
  this.aJO = null;
  this.aJP = false;
  this.aJK = null;
  this.aJL = false;
  this.aJM = null;
  this.aJN = false;
  this.aJT = false;
  this.aJU = false;
  this.aJQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aJV = "DashboardSystemSiteStats";
}
export { $c_Lpresto_DashboardView$$anon$16 as $c_Lpresto_DashboardView$$anon$16 };
$p = $c_Lpresto_DashboardView$$anon$16.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$16;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$16() {
}
export { $h_Lpresto_DashboardView$$anon$16 as $h_Lpresto_DashboardView$$anon$16 };
$h_Lpresto_DashboardView$$anon$16.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aJQ;
});
$p.L = (function() {
  if ((!this.aJJ)) {
    this.aJI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aJJ = true;
  }
  return this.aJI;
});
$p.O = (function() {
  if ((!this.aJS)) {
    this.aJR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aJS = true;
  }
  return this.aJR;
});
$p.E = (function() {
  return this.aJV;
});
$p.t = (function() {
  if ((!this.aJP)) {
    this.aJO = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("host", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aJP = true;
  }
  return this.aJO;
});
$p.M = (function() {
  if ((!this.aJL)) {
    this.aJK = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dHost$0024.$m_Lpresto_types$Host$().v9(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aJL = true;
  }
  return this.aJK;
});
$p.Q = (function() {
  if ((!this.aJN)) {
    this.aJM = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002417.$c_Lpresto_DashboardView$$anon$17();
    this.aJN = true;
  }
  return this.aJM;
});
$p.w = (function() {
  if ((!this.aJU)) {
    this.aJT = false;
    this.aJU = true;
  }
  return this.aJT;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee75) => ((p) => \u03b4scrutinee75.cGp(p)))($j_presto$002etypes$0024$002dDashboard$002dSystem$002dSite$002dStats$0024.$m_Lpresto_types$DashboardSystemSiteStats$())));
});
var $d_Lpresto_DashboardView$$anon$16 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$16, "presto.DashboardView$$anon$16", ({
  GH: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$16 as $d_Lpresto_DashboardView$$anon$16 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$16.js.map
